<template>
  <div class="showHideIcon" @click="toggleClick"></div>
  <!-- <img class="hide" src="../../assets/images/menu/hide.png" alt="" @click="toggleClick"> -->

</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick');
    },
  },
};
</script>

<style scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}

.hamburger.is-active {
  transform: rotate(180deg);
}
.hideSidebar .showHideIcon{
   background: url("../../assets/images/menu/show.png") no-repeat;
   background-size:100%;
}
.openSidebar .showHideIcon{
   background: url("../../assets/images/menu/hide.png") no-repeat;
   background-size:100%;
}
.showHideIcon{
  width: 24px;
  height: 24px;
  position: absolute;
  right: 10px;
  cursor: pointer;
}
</style>
